import { render, staticRenderFns } from "./CollectorAccountListTable.vue?vue&type=template&id=a5134d3e&"
import script from "./CollectorAccountListTable.vue?vue&type=script&lang=js&"
export * from "./CollectorAccountListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports